import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty, Input, Modal, Button, Form } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";
import arrowright from "../../assets/arrowright.svg";
import { useSelector } from "react-redux";
import Edit from "../../assets/Edit.svg";
import deleteicon from "../../assets/Order/Delete.svg";

const PromotionsTable = ({ additionalData, pagination, showEdit, onRowClick, onEditLine, onDelete }) => {
    const { t, i18n } = useTranslation();
    const [flag, setFlag] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentRow, setCurrentRow] = useState(null);
    const [form] = Form.useForm();

    const data = useMemo(() => additionalData || [], [additionalData]);

    console.log(additionalData)

    console.log(additionalData.length);

    useEffect(() => {
        if (additionalData?.length === 0 && !flag) {
            const timer = setTimeout(() => {
                setFlag(true);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [additionalData, flag]);

    const columns = useMemo(() => [
        {
            Header: t("Bulk Discount ID"),
            accessor: "id",
            Cell: ({ value }) => (
                <span className="font-medium text-[#343C6A]">#{value}</span>
            ),
        },
        {
            Header: t("Bulk Discount Type"),
            accessor: "promotion_type",
            Cell: ({ value }) => (
                <span className={`px-2 py-1 rounded-full font-medium capitalize
                    ${value === "percentage"

                    }`}>
                    {value || "—"}
                </span>
            ),
        },
        {
            Header: t("Value"),
            accessor: "value",
            Cell: ({ row }) => (
                <span className="text-sm font-medium text-[#343C6A]">
                    {row.original.promotion_type === "percentage"
                        ? `${row.original.value}%`
                        : `EGP ${Number(row.original.value).toFixed(2)}`}
                </span>
            ),
        },
        {
            Header: t("Start Date"),
            accessor: "start_date",
            Cell: ({ value }) => (
                <span className="text-sm text-gray-600">{value || "—"}</span>
            ),
        },
        {
            Header: t("End Date"),
            accessor: "end_date",
            Cell: ({ value }) => (
                <span className="text-sm text-gray-600">{value || "—"}</span>
            ),
        },
        // {
        //     Header: t("Promotion On"),
        //     accessor: "promotion_on",
        //     Cell: ({ value }) => {
        //         const labelMap = { ecom: "E-com", pos: "POS", both: "Both" };
        //         return (
        //             <span className="px-2 py-1 rounded-full text-xs font-medium ">
        //                 {labelMap[value] || value || "—"}
        //             </span>
        //         );
        //     },
        // },
        {
            Header: t("Action"),
            id: "action",
            Cell: ({ row }) => (
                <div className="flex items-center gap-3">
                    {/* View / Edit button */}
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            onEditLine?.(row.original);
                        }}
                    >
                        <img src={Edit} alt="edit" className="h-4 w-4" />

                    </button>

                    {/* Delete button */}
                    {showEdit && (
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                e.preventDefault()
                                console.log(row)
                                onDelete?.(row.original);
                            }}
                        >
                            <img src={deleteicon} alt="delete" className="h-4 w-4 mx-2" />

                        </button>
                    )}
                </div>
            ),
        },
    ], [t, showEdit, onRowClick, onDelete]);

    const {
        headerGroups,
        prepareRow,
        page,
        nextPage,
        setPageSize,
        state: { pageSize },
    } = useTable(
        {
            columns,
            data: data,
            initialState: {  pageSize: 10 },
        },
        useSortBy,
        usePagination,
        useRowSelect
    )

        const [pageIndex, setpageIndex] = useState(1);

        useEffect(() => {
        const pageDetails = {
            limit: pageSize,
            offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
        };

        if (pageSize) pagination(pageDetails);
    }, [pageSize, pageIndex,pagination]);


    const handleSave = useCallback(async () => {
        try {
            const values = await form.validateFields();
            const updated = { ...currentRow, ...values };
            onEditLine?.(updated);
            setIsModalVisible(false);
            setCurrentRow(null);
        } catch (error) {
            console.error("Validation failed:", error);
        }
    }, [form, currentRow, onEditLine]);

    const handleCancel = useCallback(() => {
        setIsModalVisible(false);
        setCurrentRow(null);
        form.resetFields();
    }, [form]);

    if (!flag && (!additionalData || additionalData.length === 0)) {
        return <ShimmerLoader />;
    }

    if (additionalData?.length === 0) {
        return (
            <div className="flex h-[50vh] items-center justify-center">
                <Empty description={t("No Bulk Discount Found")} />
            </div>
        );
    }

    return (
        <div className="mt-4 me-8">
            <div className="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
                <table  className="w-full text-sm">
                    {/* Header */}
                    <thead style={{ backgroundColor: "#78CFEC66" }}>
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column) => (
                                    <th
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                        className="px-4 py-3 text-left text-sm font-semibold text-black"
                                    >
                                        <div className="flex items-center gap-1">
                                            {column.render("Header")}
                                            {column.id !== "action" && (
                                                <img
                                                    src={Vectorsorting}
                                                    alt="sort"
                                                    className="h-3 w-3 opacity-40"
                                                />
                                            )}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>

                    {/* Body */}
                    <tbody >
                        {page.map((row,i) => {
                            prepareRow(row);
                            return (
                                <tr
                                    {...row.getRowProps()}
                                    onClick={() => onRowClick && onRowClick?.(row.original)}
                                    className={`cursor-pointer border-t border-gray-100 transition-colors hover:bg-[#F8FAFF]
                                        ${i % 2 === 0 ? "bg-white" : "bg-gray-50"}`}
                                >
                                    {row.cells.map((cell,index) => (
                                        <td
                                           key={index}
                                            {...cell.getCellProps()}
                                            className="px-4 py-3 text-gray-700 text-sm"
                                        >
                                            {cell.render("Cell")}
                                        </td>
                                    ))}

                                </tr>
                            );
                        })}

                        {page.length === 0 && (
                                    <tr>
                                        <td colSpan={"100%"}>
                                            <Empty
                                                className="mt-10"
                                                description={t("No data available")}
                                            />
                                        </td>
                                    </tr>
                                )}
                    </tbody>
                </table>
            </div>
            {/* Pagination */}

                 <CustomPagination
                            data={data?.length}
                            pageIndex={pageIndex}
                            pageCount={page?.length}
                            canPreviousPage={pageIndex != 1 ? true : false}
                            canNextPage={data?.length == pageSize ? true : false}
                            gotoPage={(page) => {
                                nextPage(page);
                            }}
                            previousPage={() => {
                                setpageIndex(pageIndex - 1);
                            }}
                            nextPage={() => {
                                setpageIndex(pageIndex + 1);
                            }}
                            pageSize={pageSize}
                            setPageSize={(pageSize) => {
                                setPageSize(pageSize);
                            }}
                        />
        </div>
    );
};

export default PromotionsTable;